"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
function onSuccess(actionContext, callContext) {
  var notificationId = callContext.options.notificationId,
    data = callContext.data;
  actionContext.dispatch('UPDATE_TASK', {
    id: notificationId,
    task: data
  });
}
var _default = function _default(config) {
  return {
    serviceName: 'updateTask',
    authenticate: true,
    config: {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      url: (0, _get.default)(config, 'endpoints.prompt.notifications.task.update')
    },
    onSuccess: onSuccess
  };
};
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(onSuccess, "onSuccess", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/services/service-configs/notifications/update-task.js");
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/services/service-configs/notifications/update-task.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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